import { create } from 'zustand';
import type { ActorRef } from '@/lib/api/types';

export type Viewer = {
  connection_id: string;
  actor: ActorRef;
  playhead_ms?: number | null;
  version_id?: string | null;
  last_seen_at: string;
};

type PresenceState = {
  rooms: Record<string, Viewer[]>;
  setRoom: (room: string, viewers: Viewer[]) => void;
};

export const usePresence = create<PresenceState>((set) => ({
  rooms: {},
  setRoom: (room, viewers) => set((s) => ({ rooms: { ...s.rooms, [room]: viewers } })),
}));
